import smoothScrollIntoView, {SmoothBehaviorOptions} from 'smooth-scroll-into-view-if-needed'

// @ts-ignore
if (!Element.prototype.scrollIntoViewIfNeeded) {
  // @ts-ignore
  Element.prototype.scrollIntoViewIfNeeded = async function (opts?: SmoothBehaviorOptions) {
    return await smoothScrollIntoView(this, opts)
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/polyfills.ts